import classes from "./UsersDisplays.module.css";
import {Button, Divider, CircularProgress, Dialog, DialogTitle, DialogContent, DialogActions, TextField, FormControl, InputLabel, Select, MenuItem, FormControlLabel, Switch, Typography, Box} from "@mui/material";
import axios from "axios";
import {path} from "../../../routes";
import {useEffect, useState} from "react";
import Row_user from "./Row_user";
import Row_display from "./Row_display";
import AddUser_modal from "../Modal/AddUser_modal";
import AddDisplaymodal from "../Modal/AddDisplaymodal";
import EditUser_modal from "../Modal/EditUser_modal";
import EditDisplay_modal from "../Modal/EditDisplay_modal";
import YesNo_modal from "../Modal/YesNo_modal";
import KioskSettings from "../Users/KIOSK_set/Kiosk_settings";

const VIENNA_HOUSE_ORG_ID = '62BDEE7F-9CE9-41BE-A80C-EF69F045D56C';

const UsersDisplays = (props) => {
    const [tabSelected, setTabSelected] = useState(0); // 0 = Users, 1 = Displays
    const [usersList, setUsersList] = useState([]);
    const [displaysList, setDisplaysList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [addUserModal, setAddUserModal] = useState(false);
    const [addDisplayModal, setAddDisplayModal] = useState(false);
    const [editUserModal, setEditUserModal] = useState(false);
    const [editDisplayModal, setEditDisplayModal] = useState(false);
    const [kioskSettingsModal, setKioskSettingsModal] = useState(false);
    const [viennaKioskSettingsModal, setViennaKioskSettingsModal] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const [selectedDisplay, setSelectedDisplay] = useState(null);
    const [selectedKioskId, setSelectedKioskId] = useState(null);
    const [runtimeDeviceGroup, setRuntimeDeviceGroup] = useState(null); // 1 = display, 2 = kiosk
    const [selectedViennaKiosk, setSelectedViennaKiosk] = useState(null);
    const [kioskSlideIntervalSec, setKioskSlideIntervalSec] = useState(15);
    const [kioskObjectFit, setKioskObjectFit] = useState('contain');
    const [kioskShowLogo, setKioskShowLogo] = useState(true);
    const [kioskShowClock, setKioskShowClock] = useState(true);
    const [kioskShowDate, setKioskShowDate] = useState(true);
    const [kioskShowTemp, setKioskShowTemp] = useState(true);
    const [kioskShowTitle, setKioskShowTitle] = useState(true);
    const [kioskSlideshowPriority, setKioskSlideshowPriority] = useState(false);
    const [kioskBackgroundColor, setKioskBackgroundColor] = useState('#012e5f');
    const [kioskTextColor, setKioskTextColor] = useState('#ffffff');
    const [kioskMeetingBgColor, setKioskMeetingBgColor] = useState('#003366');
    const [kioskMeetingTextColor, setKioskMeetingTextColor] = useState('#ffffff');
    const [kioskHeaderBackgroundColor, setKioskHeaderBackgroundColor] = useState('#eeeeee');
    const [kioskHeaderTextColor, setKioskHeaderTextColor] = useState('#333333');
    const [kioskHeaderTimeTempColor, setKioskHeaderTimeTempColor] = useState('#d92027');
    const [kioskDisplayArrows, setKioskDisplayArrows] = useState({});
    const [deleteUserConfirm, setDeleteUserConfirm] = useState(null);
    const [deleteDisplayConfirm, setDeleteDisplayConfirm] = useState(null);

    const changeTab_handler = (tab) => {
        setTabSelected(tab);
    };

    const getUsersByOrg = async () => {
        setLoading(true);
        try {
            const response = await axios.get(`${path}/getUsersByOrg/${props.cred.cOrganization_id}`);
            setUsersList(response.data);
        } catch (error) {
            try {
                const allUsers = await axios.get(`${path}/getUsers`);
                const orgUsers = allUsers.data.filter(u => u.cOrganization_id === props.cred.cOrganization_id);
                setUsersList(orgUsers);
            } catch (fallbackError) {
                // Silent fallback
            }
        } finally {
            setLoading(false);
        }
    };

    const getDisplaysByOrg = async () => {
        setLoading(true);
        try {
            // Všechna zařízení (displeje + kiosky) - stejně jako v Meeting rooms, ale včetně kiosků
            // Nejdřív načíst displeje, pak kiosky a spojit je
            const [displaysRes, kiosksRes] = await Promise.all([
                axios.get(`${path}/getDisplaysbyOrg/${props.cred.cOrganization_id}`).catch(() => ({ data: [] })),
                axios.get(`${path}/getDeviceV2?orgID=${props.cred.cOrganization_id}`).catch(() => ({ data: [] }))
            ]);
            const displays = Array.isArray(displaysRes.data) ? displaysRes.data : [];
            const kiosks = Array.isArray(kiosksRes.data) ? kiosksRes.data : [];
            
            // Spojit displeje a kiosky do jednoho seznamu
            let allDevices = [...displays, ...kiosks];
            const HOLIDAY_INN_ORG_ID = 'E15F8010-B7EB-4526-A985-F00D517EBF4C';
            const orgIdUpper = (props.cred.cOrganization_id || '').toString().trim().toUpperCase();
            if (orgIdUpper === HOLIDAY_INN_ORG_ID.toUpperCase()) {
                // Dopočítat url_id, url_room, url_orgID pro každé zařízení (API je neukládá)
                allDevices = allDevices.map((d) => {
                    const desc = (d.description || '').toLowerCase().trim();
                    const id = d.id;
                    const has = (v) => v != null && v !== '';
                    let urlId, urlRoom, urlOrgID;
                    if (has(d.url_id)) {
                        urlId = String(d.url_id);
                        urlRoom = has(d.url_room) ? String(d.url_room) : null;
                        urlOrgID = has(d.url_orgID) ? String(d.url_orgID) : (urlId === '3' || urlId === '12' || urlId === '13' ? HOLIDAY_INN_ORG_ID : null);
                    } else {
                        if (desc.includes('a - d') || desc.includes('a-d')) { urlId = '12'; urlRoom = null; urlOrgID = HOLIDAY_INN_ORG_ID; }
                        else if (desc.includes('e - f') || desc.includes('e-f')) { urlId = '13'; urlRoom = null; urlOrgID = HOLIDAY_INN_ORG_ID; }
                        else if (desc.includes('recepce') || (desc.includes('obrazovka') && desc.includes('výšku'))) { urlId = '3'; urlRoom = null; urlOrgID = HOLIDAY_INN_ORG_ID; }
                        else if (id === 23 || (desc.includes('meeting room a') || desc === 'meeting room a')) { urlId = '11'; urlRoom = '23'; urlOrgID = HOLIDAY_INN_ORG_ID; }
                        else if (id === 24 || desc.includes('meeting room b')) { urlId = '11'; urlRoom = '24'; urlOrgID = HOLIDAY_INN_ORG_ID; }
                        else if (id === 25 || desc.includes('meeting room c')) { urlId = '11'; urlRoom = '25'; urlOrgID = HOLIDAY_INN_ORG_ID; }
                        else if (id === 26 || desc.includes('meeting room d')) { urlId = '11'; urlRoom = '26'; urlOrgID = HOLIDAY_INN_ORG_ID; }
                        else { urlId = Number(d.device_group) === 1 ? '101' : '100'; urlRoom = String(d.id); urlOrgID = null; }
                    }
                    return { ...d, url_id: urlId, url_room: urlRoom ?? undefined, url_orgID: urlOrgID ?? undefined };
                });
                allDevices = [
                    { id: 'restaurant-menu', description: 'Restaurace - menu', device_group: 1, url_id: 1, url_room: null, url_orgID: null, cOrganization_id: props.cred.cOrganization_id, _synthetic: true },
                    { id: 'restaurant-speciality', description: 'Restaurace - speciality', device_group: 1, url_id: 9, url_room: null, url_orgID: null, cOrganization_id: props.cred.cOrganization_id, _synthetic: true },
                    { id: 'totem-3', description: 'Totem (recepce)', device_group: 1, url_id: 3, url_room: null, url_orgID: HOLIDAY_INN_ORG_ID, cOrganization_id: props.cred.cOrganization_id, _synthetic: true },
                    ...allDevices
                ];
            }
            setDisplaysList(allDevices);
        } catch (error) {
            const status = error?.response?.status;
            const data = error?.response?.data;
            if (status === 409) {
                const msg = typeof data === 'object' ? data?.error : null;
                const hint = typeof data === 'object' ? data?.hint : null;
                alert(`${msg || 'Organization not migrated'}\n\n${hint || 'Spusť migraci: npm run migrate:legacy-to-org'}`);
            } else {
                console.error('Error fetching displays:', error);
            }
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (tabSelected === 0) {
            getUsersByOrg();
        } else {
            getDisplaysByOrg();
        }
    }, [tabSelected, props.cred.cOrganization_id]);

    const handleAddUser = () => {
        if (!(props.cred?.type === 0 || canEditKioskSettings)) return;
        setAddUserModal(true);
    };

    const handleAddDisplay = () => {
        if (!(props.cred?.type === 0 || canEditKioskSettings)) return;
        setAddDisplayModal(true);
    };

    const handleEditUser = (user) => {
        setSelectedUser(user);
        setEditUserModal(true);
    };

    const canEditKioskSettings =
        props.cred?.allowKioskSettings === true || props.cred?.allowKioskSettings === 1;
    const canCreateUsersAndDisplays = props.cred?.type === 0 || canEditKioskSettings;
    // Uživatel může editovat řádky v tabulce Displays pokud je admin (type === 0)
    // NEBO má povoleno „User can edit kiosk settings / display settings“
    const canManageDisplays =
        props.cred?.type === 0 || canEditKioskSettings;

    const handleEditDisplay = (display) => {
        if (display._synthetic) return;
        if (display.device_group === 2) {
            const isViennaHouse = props.cred?.pravo_vienna === 1;
            if (isViennaHouse) {
                // Vienna House kiosky - každý může nastavovat
                setSelectedViennaKiosk(display);
                setViennaKioskSettingsModal(true);
            } else {
                // Ostatní kiosky - kontrola oprávnění
                if (!canEditKioskSettings) {
                    setSelectedDisplay(display);
                    setEditDisplayModal(true);
                    return;
                }
                setSelectedKioskId(String(display.id));
                setRuntimeDeviceGroup(2);
                setKioskSettingsModal(true);
                loadKioskSettings(display.id);
            }
        } else {
            // Display: vždy otevřít klasický EditDisplay modal (barvy, URL, groupa atd.)
            setSelectedDisplay(display);
            setEditDisplayModal(true);
        }
    };

    const loadKioskSettings = async (deviceId) => {
        try {
            const orgId = props.cred?.cOrganization_id;
            const url = orgId ? `${path}/getDeviceSettings/${deviceId}?orgID=${encodeURIComponent(orgId)}` : `${path}/getDeviceSettings/${deviceId}`;
            const resp = await axios.get(url);
            const s = resp.data?.settings || {};
            if (typeof s.slideIntervalSec === 'number') setKioskSlideIntervalSec(Math.max(3, Math.min(300, Math.floor(s.slideIntervalSec))));
            if (s.objectFit === 'contain' || s.objectFit === 'cover') setKioskObjectFit(s.objectFit);
            if (typeof s.showLogo === 'boolean') setKioskShowLogo(s.showLogo);
            if (typeof s.showClock === 'boolean') setKioskShowClock(s.showClock);
            if (typeof s.showDate === 'boolean') setKioskShowDate(s.showDate);
            if (typeof s.showTemp === 'boolean') setKioskShowTemp(s.showTemp);
            if (typeof s.showTitle === 'boolean') setKioskShowTitle(s.showTitle);
            if (typeof s.slideshowPriority === 'boolean') setKioskSlideshowPriority(s.slideshowPriority);
            if (typeof s.backgroundColor === 'string' && s.backgroundColor) setKioskBackgroundColor(s.backgroundColor);
            if (typeof s.meetingBgColor === 'string' && s.meetingBgColor) setKioskMeetingBgColor(s.meetingBgColor);
            else setKioskMeetingBgColor('#003366');
            if (typeof s.meetingTextColor === 'string' && s.meetingTextColor) setKioskMeetingTextColor(s.meetingTextColor);
            else setKioskMeetingTextColor('#ffffff');
            if (typeof s.headerBackgroundColor === 'string' && s.headerBackgroundColor) setKioskHeaderBackgroundColor(s.headerBackgroundColor);
            else setKioskHeaderBackgroundColor('#eeeeee');
            if (typeof s.headerTextColor === 'string' && s.headerTextColor) setKioskHeaderTextColor(s.headerTextColor);
            else setKioskHeaderTextColor('#333333');
            if (typeof s.headerTimeTempColor === 'string' && s.headerTimeTempColor) setKioskHeaderTimeTempColor(s.headerTimeTempColor);
            else setKioskHeaderTimeTempColor('#d92027');
            if (s.displayArrows && typeof s.displayArrows === 'object') setKioskDisplayArrows(s.displayArrows);
            else setKioskDisplayArrows({});
        } catch (e) {
            console.error('Failed to load kiosk settings:', e);
        }
    };

    const saveKioskSettings = async () => {
        if (!selectedKioskId) {
            alert('Select a kiosk device first.');
            return;
        }
        const payload = {
            slideIntervalSec: Math.max(3, Math.min(300, Number(kioskSlideIntervalSec || 15))),
            objectFit: kioskObjectFit === 'cover' ? 'cover' : 'contain',
            showLogo: Boolean(kioskShowLogo),
            showClock: Boolean(kioskShowClock),
            showDate: Boolean(kioskShowDate),
            showTemp: Boolean(kioskShowTemp),
            showTitle: Boolean(kioskShowTitle),
            slideshowPriority: Boolean(kioskSlideshowPriority),
            backgroundColor: String(kioskBackgroundColor || '#012e5f'),
            meetingBgColor: String(kioskMeetingBgColor || '#003366'),
            meetingTextColor: String(kioskMeetingTextColor || '#ffffff'),
            headerBackgroundColor: String(kioskHeaderBackgroundColor || '#eeeeee'),
            headerTextColor: String(kioskHeaderTextColor || '#333333'),
            headerTimeTempColor: String(kioskHeaderTimeTempColor || '#d92027'),
            demoRatio: '9:16',
            displayArrows: kioskDisplayArrows || {}
        };
        try {
            const orgId = props.cred?.cOrganization_id;
            // Merge with existing settings so keys set elsewhere (e.g. slideshowGroupIds) survive save.
            let mergedPayload = payload;
            try {
                const getUrl = orgId
                    ? `${path}/getDeviceSettings/${selectedKioskId}?orgID=${encodeURIComponent(orgId)}`
                    : `${path}/getDeviceSettings/${selectedKioskId}`;
                const currentResp = await axios.get(getUrl);
                const currentSettings = (currentResp.data?.settings && typeof currentResp.data.settings === 'object')
                    ? currentResp.data.settings
                    : {};
                mergedPayload = { ...currentSettings, ...payload };
            } catch (_) {}
            console.log(`[UsersDisplays] 💾 Saving kiosk settings for device ${selectedKioskId}:`, mergedPayload);
            const response = await axios.put(`${path}/setDeviceSettings/${selectedKioskId}`, { settings: mergedPayload, orgID: orgId });
            console.log(`[UsersDisplays] ✅ Settings saved successfully:`, response.data);
            closeKioskSettingsModal();
            alert(`Kiosk settings saved to device ${selectedKioskId}. The kiosk will update automatically.`);
        } catch (e) {
            console.error('[UsersDisplays] ❌ Failed to save kiosk settings:', e);
            console.error('[UsersDisplays] Error details:', e.response?.data);
            alert('Could not save to device. Check connection.');
        }
    };

    const copyKioskSettingsFromDevice = async (sourceDeviceId) => {
        const id = Number(sourceDeviceId);
        if (!Number.isFinite(id) || id <= 0) return;
        await loadKioskSettings(id);
    };

    const handleDeleteUser = async (id) => {
        try {
            await axios.delete(`${path}/deleteuser/${id}`);
            alert("User deleted successfully");
            setDeleteUserConfirm(null);
            getUsersByOrg();
        } catch (error) {
            alert("Failed to delete user");
            setDeleteUserConfirm(null);
        }
    };

    const handleDeleteUserRequest = (user) => {
        setDeleteUserConfirm({ id: user.id, username: user.username });
    };

    const handleDeleteDisplay = async (id) => {
        try {
            await axios.delete(`${path}/deletedisplay/${id}`);
            alert("Display deleted successfully");
            setDeleteDisplayConfirm(null);
            getDisplaysByOrg();
        } catch (error) {
            alert("Failed to delete display");
            setDeleteDisplayConfirm(null);
        }
    };

    const handleDeleteDisplayRequest = (display) => {
        if (display._synthetic) return;
        setDeleteDisplayConfirm({ id: display.id, name: display.description || display.name || `Display #${display.id}` });
    };

    const closeAddUserModal = () => {
        setAddUserModal(false);
        getUsersByOrg();
    };

    const closeAddDisplayModal = () => {
        setAddDisplayModal(false);
        getDisplaysByOrg();
    };

    const closeEditUserModal = () => {
        setEditUserModal(false);
        setSelectedUser(null);
        getUsersByOrg();
    };

    const closeEditDisplayModal = () => {
        setEditDisplayModal(false);
        setSelectedDisplay(null);
        getDisplaysByOrg();
    };

    const closeKioskSettingsModal = () => {
        setKioskSettingsModal(false);
        setSelectedKioskId(null);
        setRuntimeDeviceGroup(null);
        // Reset načtených hodnot
        setKioskSlideIntervalSec(15);
        setKioskObjectFit('contain');
        setKioskShowLogo(true);
        setKioskShowClock(true);
        setKioskShowDate(true);
        setKioskShowTemp(true);
        setKioskShowTitle(true);
        setKioskBackgroundColor('#012e5f');
        setKioskTextColor('#ffffff');
        setKioskMeetingBgColor('#003366');
        setKioskMeetingTextColor('#ffffff');
        setKioskHeaderBackgroundColor('#eeeeee');
        setKioskHeaderTextColor('#333333');
        setKioskHeaderTimeTempColor('#d92027');
        setKioskDisplayArrows({});
        getDisplaysByOrg();
    };

    const closeViennaKioskSettingsModal = () => {
        setViennaKioskSettingsModal(false);
        setSelectedViennaKiosk(null);
        getDisplaysByOrg();
    };

    return (
        <div className={classes.main}>
            <div className={classes.header}>
                <div className={classes.tabs}>
                    <Button 
                        onClick={() => changeTab_handler(0)} 
                        color="primary" 
                        variant={tabSelected === 0 ? "contained" : "text"}
                    >
                        Users
                    </Button>
                    <Divider orientation="vertical" variant="middle" flexItem />
                    <Button 
                        onClick={() => changeTab_handler(1)} 
                        color="primary" 
                        variant={tabSelected === 1 ? "contained" : "text"}
                    >
                        Displays
                    </Button>
                </div>
                <div className={classes.actions}>
                    {canCreateUsersAndDisplays && tabSelected === 0 && (
                        <Button onClick={handleAddUser} color="primary" variant="contained">
                            Add User
                        </Button>
                    )}
                    {canCreateUsersAndDisplays && tabSelected === 1 && (
                        <Button onClick={handleAddDisplay} color="primary" variant="contained">
                            Add Display
                        </Button>
                    )}
                </div>
            </div>

            <div className={classes.body}>
                {loading && (
                    <div className={classes.loader}>
                        <CircularProgress />
                    </div>
                )}

                {!loading && tabSelected === 0 && (
                    <div className={classes.table}>
                        <div className={classes.tableHeader}>
                            <div className={classes.column}>User</div>
                            <div className={classes.column}>Organization</div>
                            <div className={classes.columnActions}>Action Buttons</div>
                        </div>
                        {usersList.length > 0 ? (
                            usersList.map((user) => (
                                <Row_user
                                    key={user.id}
                                    data={user}
                                    onEdit={handleEditUser}
                                    onDeleteRequest={handleDeleteUserRequest}
                                    canManageUsers={props.cred?.type === 0}
                                />
                            ))
                        ) : (
                            <div className={classes.empty}>No users</div>
                        )}
                    </div>
                )}

                {!loading && tabSelected === 1 && (
                    <>
                        {(() => {
                            const orgIdUpper = (props.cred?.cOrganization_id || '').toString().trim().toUpperCase();
                            const isViennaHouse = props.cred?.pravo_vienna === 1 || orgIdUpper === VIENNA_HOUSE_ORG_ID.toUpperCase();
                            const viennaKiosks = isViennaHouse ? displaysList.filter((d) => Number(d.device_group) === 2) : [];
                            if (viennaKiosks.length === 0) return null;
                            return (
                                <Box sx={{ mb: 3 }}>
                                    <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2 }}>
                                        Vienna House – kiosk display settings
                                    </Typography>
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, justifyContent: 'flex-start' }}>
                                        {viennaKiosks.map((kiosk) => (
                                            <KioskSettings
                                                key={kiosk.id}
                                                data={kiosk}
                                                readOnly={false}
                                                onSaved={(updated) => {
                                                    setDisplaysList((prev) =>
                                                        prev.map((d) => (d.id === updated.id ? { ...d, KioskState: updated.KioskState } : d))
                                                    );
                                                }}
                                            />
                                        ))}
                                    </Box>
                                    <Divider sx={{ mt: 2, mb: 2 }} />
                                </Box>
                            );
                        })()}
                        <div className={classes.table}>
                            <div className={classes.tableHeader}>
                                <div className={classes.column}>Name</div>
                                <div className={classes.column}>Type</div>
                                <div className={classes.columnActions}>Action Buttons</div>
                            </div>
                            {displaysList.length > 0 ? (
                                displaysList.map((display) => (
                                    <Row_display
                                        key={display.id}
                                        data={display}
                                        orgId={props.cred.cOrganization_id}
                                        isViennaHouse={props.cred?.pravo_vienna === 1}
                                    isDiplomat={props.cred?.pravo_diplomat === 1}
                                        onEdit={handleEditDisplay}
                                        onDeleteRequest={handleDeleteDisplayRequest}
                                        canManageDisplays={canManageDisplays}
                                    />
                                ))
                            ) : (
                                <div className={classes.empty}>No displays</div>
                            )}
                        </div>
                    </>
                )}
            </div>

            {addUserModal && (
                <AddUser_modal close={closeAddUserModal} orgId={props.cred.cOrganization_id} />
            )}
            {addDisplayModal && (
                <AddDisplaymodal close={closeAddDisplayModal} org={props.cred.cOrganization_id} />
            )}
            {editUserModal && selectedUser && (
                <EditUser_modal 
                    close={closeEditUserModal} 
                    user={selectedUser}
                    orgId={props.cred.cOrganization_id}
                />
            )}
            {editDisplayModal && selectedDisplay && (
                <EditDisplay_modal 
                    close={closeEditDisplayModal} 
                    display={selectedDisplay}
                    orgId={props.cred.cOrganization_id}
                    allowKioskSettings={canEditKioskSettings}
                />
            )}
            {kioskSettingsModal && (
                <Dialog
                    open={kioskSettingsModal}
                    onClose={closeKioskSettingsModal}
                    maxWidth="md"
                    fullWidth
                    PaperProps={{ sx: { borderRadius: '12px' } }}
                >
                    <DialogTitle sx={{ fontWeight: 700 }}>
                        {runtimeDeviceGroup === 1 ? 'Display slideshow settings' : 'Kiosk settings'}
                    </DialogTitle>
                    <DialogContent sx={{ pt: 2.5, pb: 2.5 }}>
                        <Typography variant="body2" sx={{ color: '#666', mb: 2 }}>
                            {runtimeDeviceGroup === 1
                                ? 'These settings are saved to the selected display device. They control how quickly se mění obrázky, když je k displeji přiřazená groupa (slideshow).'
                                : 'These settings are saved to the selected kiosk device (database). They apply when the kiosk loads with its URL.'}
                        </Typography>

                        {displaysList.length > 0 && (
                            <Box sx={{ mb: 2 }}>
                                <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1 }}>
                                    Copy colours & background from another device
                                </Typography>
                                <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                                    <FormControl sx={{ minWidth: 200 }}>
                                        <InputLabel id="copy-from-device-label">Copy from device</InputLabel>
                                        <Select
                                            labelId="copy-from-device-label"
                                            label="Copy from device"
                                            defaultValue=""
                                            onChange={(e) => {
                                                const v = e.target.value;
                                                if (v) copyKioskSettingsFromDevice(v);
                                            }}
                                        >
                                            <MenuItem value="">
                                                <em>None</em>
                                            </MenuItem>
                                            {displaysList
                                                .filter((d) => Number(d.device_group) === runtimeDeviceGroup && d.id !== Number(selectedKioskId))
                                                .map((d) => (
                                                    <MenuItem key={d.id} value={d.id}>
                                                        {d.description || d.name || `Device #${d.id}`}
                                                    </MenuItem>
                                                ))}
                                        </Select>
                                    </FormControl>
                                </Box>
                            </Box>
                        )}

                        <Box sx={{
                            display: 'grid',
                            gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
                            gap: 2,
                            alignItems: 'center'
                        }}>
                            <TextField
                                fullWidth
                                type="number"
                                label="Slide interval (s)"
                                value={kioskSlideIntervalSec}
                                inputProps={{ min: 3, max: 300, step: 1 }}
                                onChange={(e) => setKioskSlideIntervalSec(Math.max(3, Math.min(300, Number(e.target.value || 15))))}
                            />

                            <FormControl fullWidth>
                                <InputLabel id="fit-label">Object-fit</InputLabel>
                                <Select
                                    labelId="fit-label"
                                    label="Object-fit"
                                    value={kioskObjectFit}
                                    onChange={(e) => setKioskObjectFit(e.target.value)}
                                >
                                    <MenuItem value="contain">contain (no distortion)</MenuItem>
                                    <MenuItem value="cover">cover</MenuItem>
                                </Select>
                            </FormControl>
                        </Box>

                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mt: 2, alignItems: 'center' }}>
                            <FormControlLabel control={<Switch checked={kioskShowLogo} onChange={(e) => setKioskShowLogo(e.target.checked)} />} label="Logo" />
                            <FormControlLabel control={<Switch checked={kioskShowClock} onChange={(e) => setKioskShowClock(e.target.checked)} />} label="Clock" />
                            <FormControlLabel control={<Switch checked={kioskShowDate} onChange={(e) => setKioskShowDate(e.target.checked)} />} label="Date" />
                            <FormControlLabel control={<Switch checked={kioskShowTemp} onChange={(e) => setKioskShowTemp(e.target.checked)} />} label="Temperature" />
                            <FormControlLabel control={<Switch checked={kioskShowTitle} onChange={(e) => setKioskShowTitle(e.target.checked)} />} label="Show title" />
                            <FormControlLabel control={<Switch checked={kioskSlideshowPriority} onChange={(e) => setKioskSlideshowPriority(e.target.checked)} />} label="Slideshow priority (override meetings)" />
                        </Box>

                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mt: 2 }}>
                            <Typography variant="body2" color="text.secondary" sx={{ minWidth: 100 }}>
                                Background
                            </Typography>
                            <input
                                type="color"
                                value={kioskBackgroundColor}
                                onChange={(e) => setKioskBackgroundColor(e.target.value)}
                                style={{ width: 40, height: 32, padding: 2, border: '1px solid #ccc', borderRadius: 4, cursor: 'pointer', flexShrink: 0 }}
                            />
                            <TextField
                                size="small"
                                value={kioskBackgroundColor}
                                onChange={(e) => setKioskBackgroundColor(e.target.value)}
                                sx={{ flex: 1, minWidth: 0 }}
                            />
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mt: 2 }}>
                            <Typography variant="body2" color="text.secondary" sx={{ minWidth: 100 }}>
                                Meeting background
                            </Typography>
                            <input
                                type="color"
                                value={kioskMeetingBgColor}
                                onChange={(e) => setKioskMeetingBgColor(e.target.value)}
                                style={{ width: 40, height: 32, padding: 2, border: '1px solid #ccc', borderRadius: 4, cursor: 'pointer', flexShrink: 0 }}
                            />
                            <TextField
                                size="small"
                                value={kioskMeetingBgColor}
                                onChange={(e) => setKioskMeetingBgColor(e.target.value)}
                                sx={{ flex: 1, minWidth: 0 }}
                            />
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mt: 2 }}>
                            <Typography variant="body2" color="text.secondary" sx={{ minWidth: 100 }}>
                                Text color for meeting
                            </Typography>
                            <input
                                type="color"
                                value={kioskMeetingTextColor}
                                onChange={(e) => setKioskMeetingTextColor(e.target.value)}
                                style={{ width: 40, height: 32, padding: 2, border: '1px solid #ccc', borderRadius: 4, cursor: 'pointer', flexShrink: 0 }}
                            />
                            <TextField
                                size="small"
                                value={kioskMeetingTextColor}
                                onChange={(e) => setKioskMeetingTextColor(e.target.value)}
                                sx={{ flex: 1, minWidth: 0 }}
                            />
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mt: 2 }}>
                            <Typography variant="body2" color="text.secondary" sx={{ minWidth: 100 }}>
                                Text colour
                            </Typography>
                            <input
                                type="color"
                                value={kioskTextColor}
                                onChange={(e) => setKioskTextColor(e.target.value)}
                                style={{ width: 40, height: 32, padding: 2, border: '1px solid #ccc', borderRadius: 4, cursor: 'pointer', flexShrink: 0 }}
                            />
                            <TextField
                                size="small"
                                value={kioskTextColor}
                                onChange={(e) => setKioskTextColor(e.target.value)}
                                sx={{ flex: 1, minWidth: 0 }}
                            />
                        </Box>
                        <Typography variant="subtitle2" sx={{ fontWeight: 600, mt: 2, mb: 1 }}>Header (logo, time, date, temperature)</Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mt: 1 }}>
                            <Typography variant="body2" color="text.secondary" sx={{ minWidth: 100 }}>
                                Header background
                            </Typography>
                            <input
                                type="color"
                                value={kioskHeaderBackgroundColor}
                                onChange={(e) => setKioskHeaderBackgroundColor(e.target.value)}
                                style={{ width: 40, height: 32, padding: 2, border: '1px solid #ccc', borderRadius: 4, cursor: 'pointer', flexShrink: 0 }}
                            />
                            <TextField
                                size="small"
                                value={kioskHeaderBackgroundColor}
                                onChange={(e) => setKioskHeaderBackgroundColor(e.target.value)}
                                sx={{ flex: 1, minWidth: 0 }}
                            />
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mt: 2 }}>
                            <Typography variant="body2" color="text.secondary" sx={{ minWidth: 100 }}>
                                Header text colour
                            </Typography>
                            <input
                                type="color"
                                value={kioskHeaderTextColor}
                                onChange={(e) => setKioskHeaderTextColor(e.target.value)}
                                style={{ width: 40, height: 32, padding: 2, border: '1px solid #ccc', borderRadius: 4, cursor: 'pointer', flexShrink: 0 }}
                            />
                            <TextField
                                size="small"
                                value={kioskHeaderTextColor}
                                onChange={(e) => setKioskHeaderTextColor(e.target.value)}
                                sx={{ flex: 1, minWidth: 0 }}
                            />
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mt: 2 }}>
                            <Typography variant="body2" color="text.secondary" sx={{ minWidth: 100 }}>
                                Time & temp colour
                            </Typography>
                            <input
                                type="color"
                                value={kioskHeaderTimeTempColor}
                                onChange={(e) => setKioskHeaderTimeTempColor(e.target.value)}
                                style={{ width: 40, height: 32, padding: 2, border: '1px solid #ccc', borderRadius: 4, cursor: 'pointer', flexShrink: 0 }}
                            />
                            <TextField
                                size="small"
                                value={kioskHeaderTimeTempColor}
                                onChange={(e) => setKioskHeaderTimeTempColor(e.target.value)}
                                sx={{ flex: 1, minWidth: 0 }}
                            />
                        </Box>

                        {displaysList.filter(d => Number(d.device_group) === 1).length > 0 && (
                            <Box sx={{ mt: 3 }}>
                                <Divider sx={{ mb: 2 }} />
                                <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1 }}>
                                    Display arrows (meeting list)
                                </Typography>
                                <Typography variant="body2" sx={{ color: '#666', mb: 1.5 }}>
                                    Enable and set arrow direction for each display. The arrow will appear next to the meeting on the kiosk.
                                </Typography>
                                {displaysList
                                    .filter(d => Number(d.device_group) === 1)
                                    .map(d => {
                                        const did = String(d.id);
                                        const hasArrow = did in kioskDisplayArrows;
                                        const dir = kioskDisplayArrows[did] || 'right';
                                        return (
                                            <Box key={did} sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5, flexWrap: 'wrap' }}>
                                                <Switch
                                                    size="small"
                                                    checked={hasArrow}
                                                    onChange={(e) => {
                                                        setKioskDisplayArrows(prev => {
                                                            const next = { ...prev };
                                                            if (e.target.checked) next[did] = 'right';
                                                            else delete next[did];
                                                            return next;
                                                        });
                                                    }}
                                                />
                                                <Typography variant="body2" sx={{ minWidth: 140 }}>
                                                    {d.description || `Display #${d.id}`}
                                                </Typography>
                                                {hasArrow && (
                                                    <FormControl size="small" sx={{ minWidth: 130 }}>
                                                        <Select
                                                            value={dir}
                                                            onChange={(e) => {
                                                                setKioskDisplayArrows(prev => ({ ...prev, [did]: e.target.value }));
                                                            }}
                                                        >
                                                            <MenuItem value="right">Right →</MenuItem>
                                                            <MenuItem value="left">Left ←</MenuItem>
                                                            <MenuItem value="up">Up ↑</MenuItem>
                                                            <MenuItem value="down">Down ↓</MenuItem>
                                                            <MenuItem value="up-right">Up-right ↗</MenuItem>
                                                            <MenuItem value="up-left">Up-left ↖</MenuItem>
                                                            <MenuItem value="down-right">Down-right ↘</MenuItem>
                                                            <MenuItem value="down-left">Down-left ↙</MenuItem>
                                                        </Select>
                                                    </FormControl>
                                                )}
                                            </Box>
                                        );
                                    })}
                            </Box>
                        )}
                    </DialogContent>
                    <DialogActions sx={{ px: 3, pb: 2 }}>
                        <Button variant="outlined" onClick={closeKioskSettingsModal}>Cancel</Button>
                        <Button variant="contained" disabled={!selectedKioskId} onClick={saveKioskSettings}>Save</Button>
                    </DialogActions>
                </Dialog>
            )}
            {viennaKioskSettingsModal && selectedViennaKiosk && (
                <Dialog
                    open={viennaKioskSettingsModal}
                    onClose={closeViennaKioskSettingsModal}
                    maxWidth="md"
                    fullWidth
                    PaperProps={{ sx: { borderRadius: '12px' } }}
                >
                    <DialogTitle sx={{ fontWeight: 700 }}>ViennaHouse Kiosk Settings</DialogTitle>
                    <DialogContent sx={{ pt: 2.5, pb: 2.5 }}>
                        <KioskSettings
                            data={selectedViennaKiosk}
                            onSaved={(updated) => {
                                setSelectedViennaKiosk(updated);
                                setDisplaysList(prev => prev.map(d => d.id === updated.id ? { ...d, KioskState: updated.KioskState } : d));
                            }}
                        />
                    </DialogContent>
                    <DialogActions sx={{ px: 3, pb: 2 }}>
                        <Button variant="outlined" onClick={closeViennaKioskSettingsModal}>Close</Button>
                    </DialogActions>
                </Dialog>
            )}
            {deleteUserConfirm && (
                <YesNo_modal
                    text="Opravdu chcete odstranit tohoto uživatele?"
                    line={deleteUserConfirm.username}
                    id={deleteUserConfirm.id}
                    close={() => setDeleteUserConfirm(null)}
                    delete={handleDeleteUser}
                />
            )}
            {deleteDisplayConfirm && (
                <YesNo_modal
                    text="Opravdu chcete odstranit tento zobrazovač?"
                    line={deleteDisplayConfirm.name}
                    id={deleteDisplayConfirm.id}
                    close={() => setDeleteDisplayConfirm(null)}
                    delete={handleDeleteDisplay}
                />
            )}
        </div>
    );
};

export default UsersDisplays;
